/** @jsx h */
// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import { navigationLogoItemPropType } from '../propTypes';
import { assetResolver } from '../utils';
import styled from '../utils/styled';
import { mediaBreakpointUpXL } from '../../constants/style-constants';

const Link = styled.a({
  /* stylelint-disable selector-type-case, selector-type-no-unknown */
  display: 'none',
  flex: '1 0 540px',

  [mediaBreakpointUpXL]: {
    margin: '0 0 0 30px',
    display: 'block',
  },
});

const Img = styled.img({
  height: 'auto',
  width: '100%',
});

const ExplorePoster = ({ item }) => {
  const src = item ? item.coverImage.file.url : assetResolver('spyscape-menu.svg');

  return (
    <Link href={item && item.link}>
      <Img src={src} alt="Spyscape" width="612" height="400" />
    </Link>
  );
};

ExplorePoster.propTypes = {
  item: navigationLogoItemPropType,
};

ExplorePoster.defaultProps = {
  item: null,
};

export default ExplorePoster;
